export default "__VITE_ASSET__7f49edd4__"